import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import axios from 'axios';
import { Box, Typography, Button, Paper } from '@mui/material';
import Heading from '../../Components/heading.tsx';
import OrderSummaryScreen from './order-summary.tsx';

interface OrderDetails {
  id: string;
  order_id: string;
  name: string;
  address: string;
  pincode: string;
  order_type: string;
  payment_mode: string;
  amount: number;
  [key: string]: any;
}

const containerStyle = {
  width: '100%',
  height: '300px',
};

const center = {
  lat: 10.0187,
  lng: 76.3612,
};

const RouteMapScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const order = location.state as OrderDetails | null;
  const [destinationCoords, setDestinationCoords] = useState<{ lat: number; lng: number }>(center);
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [deliveryStatus, setDeliveryStatus] = useState('');
  const [urlParams, setUrlParams] = useState({
      token: '',
      userId: '',
      vehicleId:''
    });
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyA5izcJ7TGIrfklTCrMx3Q2JmeK_zld1sc',
    libraries: ['places'],
  });

  useEffect(() => {
    console.log(order);
         const queryParams = new URLSearchParams(window.location.search);
      setUrlParams({
        token: queryParams.get('token') || '',
        userId: queryParams.get('user_id') || '',
        vehicleId:queryParams.get('vehicle_id') || '',
      });
    if (!order) {
      navigate(-1);
      return;
    }

    const fetchCoordinates = async () => {
      try {
        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json`,
          {
            params: {
              address: `${order.address}, ${order.pincode}`,
              key: 'AIzaSyA5izcJ7TGIrfklTCrMx3Q2JmeK_zld1sc',
            },
          }
        );

        const results = response.data.results;
        if (results.length > 0) {
          const { lat, lng } = results[0].geometry.location;
          setDestinationCoords({ lat, lng });
        }
      } catch (err) {
        console.error('Geocoding error:', err);
      }
    };

    fetchCoordinates();
  }, [order, navigate]);

  const handleBack = () => {
    window.history.back();
  };

  const handleMarkerClick = () => {
    window.open(`https://www.google.com/maps?q=${destinationCoords.lat},${destinationCoords.lng}`);
  };

  if (!order) return null;

  return (
    <Box>
      <Box style={{ marginTop: '30px' }}>
        <Heading title="Orders" onBackClick={handleBack} />
      </Box>

      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={destinationCoords}
          zoom={14}
        >
          <Marker 
            position={destinationCoords}
            onClick={handleMarkerClick}
          />
        </GoogleMap>
      ) : (
        <Typography align="center" mt={2}>
          Loading map...
        </Typography>
      )}

      <Paper elevation={3} sx={{ margin: 2, padding: 2 }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="contained" color="success">{order.type}</Button>
          <Button variant="contained" color="error">{order.cod?'COD':'Prepaid'}: ₹{order.amount || 0}</Button>
        </Box>

        <Typography variant="subtitle1" mt={2}>
          <strong>{order.order_id}</strong> - {order.name}
        </Typography>

        <Typography variant="body2" mt={1}>
          <strong>Shipping Address:</strong><br />
          {order.address},<br />
          {order.pincode}
        </Typography>

        <Typography variant="body2" mt={1}>
          <strong>Payment Mode:</strong> {order.cod ? 'COD' :'Prepaid'}
        </Typography>

        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 3 }}
          color="primary"
          onClick={() =>
            navigate(`/wv/order-summary?&user_id=${urlParams.userId}&order_id=${order?.id}&vehicle_id=${urlParams.vehicleId}&token=${urlParams.token}`, {
              state: {
                order,
              },
            })
          }
        >
          Reached Destination
        </Button>
      </Paper>

      {showOrderSummary && (
        <OrderSummaryScreen
          deliveryStatus={deliveryStatus}
          onClose={() => setShowOrderSummary(false)}
          orderId={order.id}
          warehouseId={2345}
          vehicleId={484}
        />
      )}
    </Box>
  );
};

export default RouteMapScreen;